import StringHelper from './StringHelper';
import DateHelper from './DateHelper';
import moment from 'moment-jalaali';
export default {
  _email() {
    return [
      { type: 'email', message: `ایمیل معتبر نیست` },
    ];
  },
  _hasWhiteSpace(label) {
    return [
      {
        validator: (_, value) => {
          if (value)
            if (value.indexOf(' ') >= 0) {
              return Promise.reject(`${label} معتبر نیست`);
            }
          return Promise.resolve();
        },
      },
    ];
  },
  _mobile() {
    return [
      {
        validator: (_, value) => {
          if (value && !StringHelper.isMobile(value)) {
            return Promise.reject(`شماره موبایل معتبر نیست`);
          }
          // if (!value) {
          //   return Promise.reject(`شماره موبایل اجباری ست`);
          // }
          return Promise.resolve();
        },
      },
    ];
  },
  _phone() {
    return [
      {
        validator: (_, value) => {
          if (value && !StringHelper.isPhone(value)) {
            return Promise.reject(`شماره تلفن معتبر نیست`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _transformPrice() {
    return [
      {
        transform(value) {
          if (value) {
            return value.replace(/,/g, '');
          }
        },
      },
    ];
  },
  _farsi(label) {
    return [
      {
        validator: (_, value) => {
          if (value && !StringHelper.isFarsi(value)) {
            return Promise.reject(`${label} باید فارسی باشد`);
          }
          // if (!value) {
          //   return Promise.reject(`${label} اجباری ست`);
          // }
          return Promise.resolve();
        }
      },
    ];
  },
  _english(label) {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isEnglish(value)) {
            return Promise.reject(`${label} باید انگلیسی باشد`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _nationalCode() {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isNationalCode(value)) {
            return Promise.reject(`کد ملی معتبر نیست`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _userName() {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isUserName(value)) {
            return Promise.reject(`نام کاربری صحیح نیست`);
          }
          return Promise.resolve();
        }

      }
    ]
  },
  _idNumber() {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isIdNumber(value)) {
            return Promise.reject(`شماره شناسنامه معتبر نیست`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _password() {
    return [
      {
        validator: (_, value) => {
          if (value && !StringHelper.isStrongPassword(value)) {
            return Promise.reject(`رمز عبور شامل یک حرف بزرگ و یک عدد`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _passport() {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isPassport(value)) {
            return Promise.reject(`شماره پاسپورت معتبر نیست`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _postalCode() {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isPostalCode(value)) {
            return Promise.reject(`کد پستی معتبر نیست`);
          }
          return Promise.resolve();
        }
      },
    ];
  },
  _date(label) {
    return [
      {
        validator: (_, value) => {
          if (!DateHelper.isObjValidDate(value)) {
            return Promise.reject(`${label} معتبر نیست`);
          }
          return Promise.resolve();
        },
      },
    ];
  },
  number(label) {
    return [
      {
        validator: (_, value) => {
          if (value && !StringHelper.isNumber(value)) {
            return Promise.reject(`${label} معتبر نیست`);
          }
          return Promise.resolve();
        },
      },
    ];
  },
  _positive(label) {
    return [
      {
        validator: (_, value) => {
          if (!StringHelper.isNumber(value)) {
            return Promise.reject(`${label} معتبر نیست`);
          }
          return Promise.resolve();
        },
      },
    ];
  },
  _maxValue(label, maxValue) {
    return [
      {
        validator: (_, value) => {
          // if (maxValue && parseInt(value.replace(/,/g, '')) > parseInt(maxValue)) {
          if (maxValue && value > parseInt(maxValue)) {
            return Promise.reject(`${label} بیشتر از حد مجاز است`);
          }
          return Promise.resolve();
        },
      },
    ];
  },
  price(label) {
    return [
      ...this._transformPrice(),
      ...this.required(label),
      ...this.number(label)
    ];
  },
  required(label) {
    return [
      { required: true, message: `${label} اجباری است` },
    ];
  },
  email() {
    return [
      ...this.required('ایمیل'),
      ...this._email(),
      ...this._hasWhiteSpace('ایمیل'),
    ];
  },
  receiverName() {
    return [
      ...this.required('نام تحویل گیرنده'),
      ...this._farsi('نام تحویل گیرنده'),
    ];
  },
  mobile() {
    return [
      ...this.required(''),
      ...this._mobile(),
      ...this._hasWhiteSpace('موبایل'),
    ];
  },
  firstname() {
    return [
      ...this.required('نام'),
      ...this._farsi('نام'),
    ];
  },
  lastname() {
    return [
      ...this.required('نام خانوادگی'),
      ...this._farsi('نام خانوادگی'),
    ];
  },
  latinFirstname() {
    return [
      ...this.required('نام لاتین'),
      ...this._english('نام لاتین'),
    ];
  },
  latinLastname() {
    return [
      ...this.required('نام خانوادگی لاتین'),
      ...this._english('نام خانوادگی لاتین'),
    ];
  },
  fatherName() {
    return [
      ...this.required('نام پدر'),
      ...this._farsi('نام پدر'),
    ];
  },
  nationalCode() {
    return [
      ...this._nationalCode(),
      ...this._hasWhiteSpace('کد ملی'),

    ];
  },
  idNumber() {
    return [
      ...this.required('شماره شناسنامه'),
      ...this._idNumber(),
      ...this._hasWhiteSpace('شماره شناسنامه'),
    ];
  },
  userFormPassword() {
    return [
      ...this.required('کلمه عبور'),
      // ...this._password('کلمه عبور'),
      { min: 7, message: 'کلمه عبور باید ۷ حرف باشد' }
    ];
  },
  password() {
    return [
      // ...this._password('کلمه عبور'),
      { min: 7, message: 'کلمه عبور باید ۷ حرف باشد' }
    ];
  },
  _maxBirthdate(maxValue) {
    return [
      {
        validator: (_, value) => {
          if (maxValue === 'today' &&
            moment(DateHelper.objToDate(value)).isAfter(moment())) {
            return Promise.reject(`تاریخ انتخابی مجاز نیست`);
          }
          return Promise.resolve();
        },
      },
    ];
  },
  birthdate(maxValue) {
    return [
      ...this._maxBirthdate(maxValue),
      ...this.required('تاریخ تولد'),
      ...this._date('تاریخ تولد'),
    ];
  },
  previousExpiration(maxValue) {
    return [
      ...this._maxBirthdate(maxValue),
      ...this.required('تاریخ اتمام بیمه‌نامه قبلی'),
      ...this._date('تاریخ اتمام بیمه‌نامه قبلی'),
    ];
  },
  releaseDate(maxValue) {
    return [
      ...this._maxBirthdate(maxValue),
      ...this.required('تاریخ اتمام بیمه‌نامه قبلی'),
      ...this._date('تاریخ اتمام بیمه‌نامه قبلی'),
    ];
  },
  phone() {
    return [
      ...this._phone(),
      ...this._hasWhiteSpace('شماره تلفن'),
    ];
  },
  passport() {
    return [
      ...this.required('شماره پاسپورت'),
      ...this._passport(),
      ...this._hasWhiteSpace('شماره پاسپورت'),
    ];
  },
  postalCode() {
    return [
      ...this.required('کد پستی'),
      ...this._postalCode(),
      ...this._hasWhiteSpace('کد پستی'),
    ];
  },
  userName() {
    return [
      ...this.required('نام کاربری'),
      ...this._userName(),
      // ...this._english('نام کاربری'),
      ...this._hasWhiteSpace('نام کاربری')]
  },
  images(imageInfo) {
    return imageInfo.some((info) => {
      if (info.Required && !info.File) {
        return true;
      }
      return false;
    });
  },
  decimalNumber(label) {
    return [{
      validator: (_, value) => {
        if (value && !StringHelper.isDecimalNumber(value)) {
          return Promise.reject(`${label} معتبر نیست`);
        }
        return Promise.resolve();
      }
    }]
  },
  accountNumber(label) {
    return [
      ...this.required(label),
      ...this.number(label)
    ];
  },
  borderRadius(label, maxValue) {
    return [
      ...this._maxValue(label, maxValue),
    ];
  },
};
